import { get } from 'lodash';
import { createSelector } from 'reselect';

export const getApplicationData = state =>
  get(state, 'FamilyMatchUtilityState.applicationData', []);

export const getStudentData = state =>
  get(state, 'FamilyMatchUtilityState.studentData', []);

export const getSelectedSystemId = state =>
  get(state, 'FamilyMatchUtilityState.selectedSystemId', null);

export const getSelectedHHId = state =>
  get(state, 'FamilyMatchUtilityState.selectedHHId', null);

export const getSelectedStudentIdSeeds = state =>
  get(state, 'FamilyMatchUtilityState.selectedStudentIdSeeds', []);

export const getSelectedConfidence = state =>
  get(state, 'FamilyMatchUtilityState.selectedConfidence', null);

export const checkApplication = state =>
  get(state, 'FamilyMatchUtilityState.applicationData', []);

export const checkStudent = state =>
  get(state, 'FamilyMatchUtilityState.studentData', []);

export const getFetchingApplications = state =>
  get(state, 'FamilyMatchUtilityState.fetchingApplications', false);

export const getFetchingStudents = state =>
  get(state, 'FamilyMatchUtilityState.fetchingStudents', false);

export const getError = state =>
  get(state, 'FamilyMatchUtilityState.fetchError', '');

export const getSavedSuccessfully = state =>
  get(state, 'FamilyMatchUtilityState.savedSuccessfully', false);

export const getNoStudentsFlag = state =>
  get(state, 'FamilyMatchUtilityState.noStudentsFound', false);

export const getHistoryState = state =>
  get(state, 'FamilyMatchUtilityState.isHistoryShown', false);

export const getAlteredApplications = state =>
  get(state, 'FamilyMatchUtilityState.alteredApplications', false);

export const getStudentsByHHId = createSelector(
  [getSelectedHHId, getStudentData],
  (HHId, studentData) => {
    return studentData.filter(x => x.PossibleHHId === HHId);
  }
);



// WEBPACK FOOTER //
// ./src/pages/familymatchutility/state/selectors.js